module.exports = __webpack_public_path__ + "img/be.5df4c8dd.svg";